import Vue from "vue";
import VueRouter from "vue-router";
// views
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import Logout from "../views/Logout.vue";
import Register from "../views/Register";
import PasswordReset from "../views/PasswordReset";
import PasswordRequest from "../views/PasswordRequest";
import DashboardHome from "../views/DashboardHome";
import HostDashboardHome from "../views/HostDashboardHome";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "Welcome to TopQuiz!",
      metaTags: [
        {
          name: "description",
          content: "The online pub quiz score tracker!"
        },
        {
          property: "og:description",
          content: "The online pub quiz score tracker!"
        }
      ],
      noAuth: true
    }
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: "TopQuiz Login",
      noAuth: true
    }
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout,
    meta: {
      title: "TopQuiz Logout"
    }
  },
  {
    path: "/spectate/:quizID",
    name: "Spectate",
    component: () => import("../views/Spectate.vue"),
    meta: {
      title: "TopQuiz Spectator",
      metaTags: [
        {
          name: "description",
          content: "Watch you pub quiz scores live!"
        },
        {
          property: "og:description",
          content: "Watch you pub quiz scores live!"
        }
      ],
      noAuth: true
    }
  },
  {
    path: "/play/:quizID",
    name: "Play",
    component: () => import("../views/Play.vue"),
    meta: {
      title: "TopQuiz Scoring",
      metaTags: [
        {
          name: "description",
          content: "Manage you pub quiz scores online!"
        },
        {
          property: "og:description",
          content: "Manage you pub quiz scores online!"
        }
      ]
    }
  },
  {
    path: "/guest",
    name: "Guest",
    component: () => import("../views/Guest.vue"),
    meta: {
      title: "TopQuiz Guest Account",
      noAuth: true
    }
  },
  {
    path: "/reset/:user/:code",
    name: "Reset Password",
    component: PasswordReset,
    meta: {
      title: "TopQuiz Password Reset",
      noAuth: true
    }
  },
  {
    path: "/password",
    name: "Password",
    component: PasswordRequest,
    meta: {
      title: "TopQuiz Password Request",
      noAuth: true
    }
  },
  {
    path: "/register/:action/:param/",
    name: "RegisterActionSingleParam",
    component: Register,
    meta: {
      title: "TopQuiz Registration",
      noAuth: true
    }
  },
  {
    path: "/register/:action/:param/:param2",
    name: "RegisterAction",
    component: Register,
    meta: {
      title: "TopQuiz Registration",
      noAuth: true
    }
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: {
      title: "TopQuiz Registration",
      noAuth: true
    }
  },
  {
    path: "/dashboard",
    children: [
      // Note we provide the above parent route name on the default child tab
      // route to ensure this tab is rendered by default when using named routes
      { path: "", component: DashboardHome, name: "Dashboard" },
      { path: "teams", component: () => import("../views/DashboardTeams") },
      {
        path: "history",
        component: () => import("../views/DashboardQuizHistory")
      }
    ],
    component: () => import("../views/Dashboard.vue"),
    meta: {
      title: "TopQuiz Dashboard",
      metaTags: [
        {
          name: "description",
          content: "Join quizzes, manage your teams, track your scores!"
        },
        {
          property: "og:description",
          content: "Join quizzes, manage your teams, track your scores!"
        }
      ]
    }
  },
  {
    path: "/admin",
    children: [
      // Note we provide the above parent route name on the default child tab
      // route to ensure this tab is rendered by default when using named routes
      {
        path: "",
        component: () => import("../views/AdminDashboardHome"),
        name: "AdminDashboard"
      }
    ],
    component: () => import("../views/AdminDashboard.vue")
  },
  {
    path: "/host",
    children: [
      // Note we provide the above parent route name on the default child tab
      // route to ensure this tab is rendered by default when using named routes
      { path: "", component: HostDashboardHome, name: "HostDashboard" },
      { path: "new", component: () => import("../views/HostDashboardNew") },
      { path: "go/:id", component: () => import("../views/HostGoQuiz") },
      {
        path: "history",
        component: () => import("../views/HostDashboardHistory")
      }
    ],
    component: () => import("../views/HostDashboard.vue"),
    meta: {
      title: "TopQuiz Hosting",
      metaTags: [
        {
          name: "description",
          content: "Join quizzes, manage your teams, track your scores!"
        },
        {
          property: "og:description",
          content: "Join quizzes, manage your teams, track your scores!"
        }
      ]
    }
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
    meta: {
      title: "TopQuiz About",
      noAuth: true
    }
  },
  {
    path: "/changes",
    name: "Changes",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Changes.vue"),
    meta: {
      title: "TopQuiz Changelog",
      noAuth: true
    }
  },
  {
    path: "/donations",
    name: "Donations",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Donations.vue"),
    meta: {
      title: "TopQuiz Donations",
      noAuth: true
    }
  },
  {
    path: "/donated",
    name: "Donated",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Donated.vue"),
    meta: {
      title: "Thank YOU",
      noAuth: true
    }
  },
  {
    path: "/join/:code",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Join.vue"),
    meta: {
      noAuth: true
    }
  },
  {
    path: "*",
    component: Home // Todo: make not found page
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);
  //const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(
    document.querySelectorAll("[data-vue-router-controlled]")
  ).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router;
